import {generateClient} from "aws-amplify/api";
import {appSyncConfig} from "./config";

export const pipelinesClient = generateClient({
                                                  endpoint: appSyncConfig.endpoint,
                                                  region: appSyncConfig.region,
                                                  authMode: 'userPool'
                                              });
